import { useContext } from 'react';

import { TableUpdateRowHandlerContext } from 'context/todoRow/TodoRowContext';

export const useTodoRowContext = () => {
  const todoRowContext = useContext(TableUpdateRowHandlerContext);

  return todoRowContext;
};
